import axios from 'axios';

export default {
  namespaced: true,
  state: {
    // heading: 'Ielogošanās',
    component: 'login',
    errors: {},
    form: {},
    loading: false,
    authorized: false,
    message: '',
    userData: {},
  },
  getters: {
    getHeading(state, getters, rootState, rootGetters) {
      switch (state.component) {
        case 'login':
          return $r.head_login;
          case 'register':
          return $r.head_register;
        default:
          return null;
      }
    },
    getMessage(state) {
      return state.message;
    },
    getUserData(state) {
      return state.userData;
    },
    getResource: (state) => (key) => {
      return $r[key];
    },
  },
  mutations: {    
    loadComponent(state, type) {
      state.errors = {};
      state.form = {};
      state.loading = false;
      state.component = type;
    },
    setErrors(state, errors) {
      state.errors = errors;
    },
    setForm(state, data) {
      state.form = data;
    },
    setLoading(state, status) {
      state.loading = status;
    },
    setAuthorized(state) {
      state.authorized = true;
    },
    setRegistered(state) {
      state.component = 'message';
      state.message = $r['register_msg'];
    },
    setRecoverSent(state) {
      state.component = 'message';
      state.message = $r['recover_msg'];
    },
    setUserData(state, data) {
      state.userData = data;
    },    
  },
  actions: {
    login(context) {
      context.commit('setLoading', true);
      axios.post('/' + window.lang + '/user/login', context.state.form)
        .then(response => {
          if (response.data.status == true) {

            if (window.hasOwnProperty('userData') && window.userData.hasOwnProperty('env'))
              response.data.user.env = window.userData.env;

            context.commit('setErrors', {});
            context.commit('setAuthorized');
            context.commit('setUserData', response.data.user);
          } else {
            context.commit('setErrors', { message: $r['login_fail_msg'] });
          }
        })
        .catch(error => {
          console.error(error);
          let e = {};
          _.forEach(error.response.data.errors, (errArray, key) => {
            e[key] = errArray[0];
          });
          context.commit('setErrors', e);
        })
        .then(() => {
          context.commit('setLoading', false);
        });
    },
    register(context) {
      context.commit('setLoading', true);
      axios.post('/' + window.lang + '/user/register', context.state.form)
        .then(response => {
          if (response.data.status == true) {
            context.commit('setErrors', {});
            context.commit('setRegistered');
          } else {
            context.commit('setErrors', { message: $r['register_fail'] });
          }
        })
        .catch(error => {
          console.log(error);
          let e = {};
          _.forEach(error.response.data.errors, (errArray, key) => {
            e[key] = errArray[0];
          });
          context.commit('setErrors', e);
        })
        .then(() => {
          context.commit('setLoading', false);
        });
    },
    recover(context) {
      context.commit('setLoading', true);
      axios.post('/' + window.lang + '/user/recover', context.state.form)
        .then(response => {
          if (response.data.status == true) {
            context.commit('setErrors', {});
            context.commit('setRecoverSent');
          } else {
            context.commit('setErrors', { message: $r['recover_fail'] });
          }
        })
        .catch(error => {
          console.log(error);
          let e = {};
          _.forEach(error.response.data.errors, (errArray, key) => {
            e[key] = errArray[0];
          });
          context.commit('setErrors', e);
        })
        .then(() => {
          context.commit('setLoading', false);
        });
    },
  },
}